import ajax from '../../lib/ajax';
const cloud = {
    namespaced: true,
    state: {

    },
    actions: {
        async login(state: any, payload: any) {
            let rep = await ajax.post('/api/Cloud/login', payload.data);
            return rep.data.result;
        },
        async getRooms(state: any, payload: any) {
            let rep = await ajax.get('/api/Cloud/GetRooms', { params: payload.data });
            return rep.data.result;
        },
        async bind(state: any, payload: any) {
            let rep = await ajax.post('/api/Cloud/Bind', payload.data);
            return rep.data.result;
        }
    }
}
export default cloud;